import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import Layout from "../../components/layout/NewLayout";
import ModalTemplate from "../../components/modal/Modal";
// import LoginForm from "./LoginForm";
// import LoginForm from "./LoginForm3";
import LoginForm from "./LoginForm4";
import { Box, Button, Typography } from "@mui/material";
import Image from "material-ui-image";
import infoIcon from "../../assets/images/info-circle.png";
// import qwizLogo from "../../assets/images/qwiz-logo.png";
import "@fontsource/poppins";
import qwizLogo from "../../assets/Images2/qwizfun_logo.svg";
import { useFetchLandingPageSettings } from "../../hooks/api/fetch";
function Login({ setGamePreloader }) {
  const { id } = useParams();
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const landingPageAPI = useFetchLandingPageSettings(id);
  useEffect(() => {
    if (landingPageAPI?.data?.landing_page_setting?.landing_page_header)
      sessionStorage.setItem(
        "logo",
        landingPageAPI?.data?.landing_page_setting?.landing_page_header
      );
  }, [landingPageAPI?.data?.landing_page_setting?.landing_page_header]);
  if (landingPageAPI?.isLoading) {
    return <>Loading... Please wait</>;
  }
  return (
    <Layout
      logo={qwizLogo}
      // logo={
      //   landingPageAPI?.data?.landing_page_setting?.landing_page_header
      //     ?.header_logo || qwizLogo
      // }
      url={`/${
        window.location.href.includes("corporate") ? "corporate" : "event"
      }/${id}`}
    >
      {/* <Box pt={4} sx={{ display: "flex", justifyContent: "center" }}>
        <Box width={64}>
          <Image
            src={
              landingPageAPI?.data?.landing_page_setting?.landing_page_header
                ?.header_logo || qwizLogo
            }
            color="transparent"
          />
        </Box>
      </Box> */}

      <Box
        // mt={2}
        p={2}
        sx={{
          minHeight: "calc(100vh - 200px)",
        }}
        fontFamily={"'Poppins', san-serif"}
      >
        <Typography
          variant="h6"
          m={2}
          align="left"
          fontSize={24}
          fontWeight={600}
        >
          {" "}
          Login
        </Typography>
        <LoginForm
          setErrorMessage={setErrorMessage}
          setOpenErrorModal={setOpenErrorModal}
          setGamePreloader={setGamePreloader}
        />
        <LoginError
          openModal={openErrorModal}
          setOpenModal={setOpenErrorModal}
          message={errorMessage}
        />
      </Box>
    </Layout>
  );
}

export default Login;
function LoginError({ openModal, setOpenModal, message }) {
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <ModalTemplate open={openModal} handleClose={handleCloseModal}>
      <Box mt={1} py={1} sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "48px", height: "48px" }}>
          <Image src={infoIcon} color="transparent" />
        </Box>
      </Box>
      <Typography variant="body1" align="center">
        {message}
      </Typography>
      <Box py={1} sx={{ display: "flex", justifyContent: "center" }}>
        <Button variant="contained" color="success" onClick={handleCloseModal}>
          Close
        </Button>
      </Box>
    </ModalTemplate>
  );
}
